(function () {
  if (window.__swatchPopupReady) return;
  window.__swatchPopupReady = true;

  const ANIMATION_DURATION = 900;
  const ACTIVE_CELL_SELECTOR =
    '.enhanced-swatch-cell:has(.enhanced-swatch-popups):has(input[type=radio]:checked)';
  let animationStartTime = null;

  const findCheckedPopupCell = () => document.querySelector(ACTIVE_CELL_SELECTOR);

  const startAnimation = (cell, elapsedMs = 0) => {
    cell.classList.remove('popup-animating');
    cell.style.removeProperty('--popup-anim-delay');
    void cell.offsetWidth;

    if (elapsedMs > 0) {
      cell.style.setProperty('--popup-anim-delay', `-${elapsedMs}ms`);
    }
    cell.classList.add('popup-animating');

    clearTimeout(cell._popupAnimTimer);
    cell._popupAnimTimer = setTimeout(() => {
      cell.classList.remove('popup-animating');
      cell.style.removeProperty('--popup-anim-delay');
    }, Math.max(ANIMATION_DURATION - elapsedMs, 0) + 100);
  };

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (target?.type !== 'radio') return;
      const cell = target.closest('.enhanced-swatch-cell');
      if (!cell?.querySelector('.enhanced-swatch-popups')) return;

      animationStartTime = performance.now();
      startAnimation(cell);
    },
    true
  );

  document.addEventListener('variant:changed', () => {
    if (animationStartTime === null) return;
    const elapsed = performance.now() - animationStartTime;
    if (elapsed >= ANIMATION_DURATION) {
      animationStartTime = null;
      return;
    }
    const cell = findCheckedPopupCell();
    if (!cell) {
      animationStartTime = null;
      return;
    }
    startAnimation(cell, elapsed);
  });

  const initialTrigger = () => {
    const cell = findCheckedPopupCell();
    if (!cell) return;
    animationStartTime = performance.now();
    startAnimation(cell);
  };

  const schedule = () => setTimeout(initialTrigger, 50);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
